import React from 'react'
import { ExternalLink, ExternalLinkProps } from '@/atoms/ExternalLink'
import { ReactFCC } from '@/types/react'
import { buildAnalyticsLink } from '@/utils/AnalyticsLinkBuilder'
import { useSafeRouter } from '@/utils/nextUtils/safe-router'

export interface AccelerationFundLinkProps extends ExternalLinkProps {
  linkContext?: string
  projectSlug?: string
}

export const AccelerationFundLink: ReactFCC<AccelerationFundLinkProps> = ({
  children,
  href,
  linkContext = 'angel-web',
  projectSlug,
  ...rest
}) => {
  const { asPath } = useSafeRouter()

  return (
    <ExternalLink href={buildAnalyticsLink({ href, path: asPath, campaign: projectSlug, linkContext })} {...rest}>
      {children}
    </ExternalLink>
  )
}
